import {Action} from '@ngrx/store';
import * as _ from 'lodash';
import {LoadTargetSuccessAction, targetActionTypes} from '../actions/target-load';
import {contentActionTypes} from '../actions/content-load';

export interface SalesStatisticRevenuesState {
  // tslint:disable-next-line:no-any
  array: any[];
}

const initialState: SalesStatisticRevenuesState = {
  array: [],
};

export function SalesStatisticRevenuesReducer(state: SalesStatisticRevenuesState = initialState, action: Action): SalesStatisticRevenuesState {
  switch (action.type) {
    case contentActionTypes.LOAD_SUCCESS:
      return handleLoadSalesStatisticRevenuesSuccessAction(state, action);
    case contentActionTypes.LOAD_FAIL:
      return handleLoadErrorActions(state);
    default:
      return state;
  }
}
function handleLoadSalesStatisticRevenuesSuccessAction(state: SalesStatisticRevenuesState, action: LoadTargetSuccessAction): SalesStatisticRevenuesState {
  const newState: SalesStatisticRevenuesState = {
    ... state,
    array: action.payload.array,
  };
  return newState;
}

function handleLoadErrorActions(state: SalesStatisticRevenuesState): SalesStatisticRevenuesState {
  return state;
}

export const salesStatisticRevenuesStateSelectors = {
  array: (state: SalesStatisticRevenuesState) => _.get(state, 'array', []),
};
